<template>
  <div id="app" :class="{ isIE: isIE }">
    <template v-if="!isIE">
      <router-view />
    </template>
    <!-- <module-loading-overlay :loading="isLoading" /> -->
    <module-browser-hint />
  </div>
</template>

<style lang="scss">
@import "@/pages/cathayfitback/assets/styles/index.scss";
</style>

<script>
export default {
  metaInfo() {
    return {
      title: this.title || document.title
    };
  },
  data() {
    return {
      title: ""
    };
  },
  watch: {
    $route(to, from) {
      this.title = this.$store.getters.getTitle(this.$route.path);
    }
  },
  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    },
    isSos() {
      return this.$store.state.isSos;
    },
    isIE() {
      return (
        navigator.userAgent.indexOf("MSIE") > -1 ||
        navigator.userAgent.indexOf("Trident") > -1
      );
    }
  },
  mounted() {
    this.lockDefined();
    this.lockEvent();
    this.copyBlank();
    this.$store.dispatch("setMata");
  },
  methods: {
    lockDefined() {
      document.oncontextmenu = function () {
        window.event.returnValue = false;
      };
    },
    lockEvent() {
      window.addEventListener("contextmenu", e => e.preventDefault());
    },
    copyBlank() {
      document.body.oncopy = function () {
        event.returnValue = false;
      };
    }
  }
};
</script>

<style lang="scss">
#app {
  &.isIE {
    background: rgb(121 187 55 / 30%);
  }
}
</style>
